var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimationicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.86129 43.2399C14.756 43.2399 18.7226 39.2734 18.7226 34.3786C18.7226 29.4839 14.756 25.5173 9.86129 25.5173C4.96657 25.5173 1 29.4839 1 34.3786C1 39.2734 4.96657 43.2399 9.86129 43.2399Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.4941 30.8193C24.3888 30.8193 28.3554 26.8527 28.3554 21.958C28.3554 17.0632 24.3888 13.0967 19.4941 13.0967C14.5994 13.0967 10.6328 17.0632 10.6328 21.958C10.6328 26.8527 14.5994 30.8193 19.4941 30.8193Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30 18.7226C34.8947 18.7226 38.8613 14.756 38.8613 9.86129C38.8613 4.96657 34.8947 1 30 1C25.1052 1 21.1387 4.96657 21.1387 9.86129C21.1387 14.756 25.1052 18.7226 30 18.7226Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationicon);
export default __webpack_public_path__ + "static/media/animationicon.73555e92bc491d6be74374c167894693.svg";
export { ForwardRef as ReactComponent };